var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClSicuro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 166,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFF",
    cx: 82.704,
    cy: 82.544,
    rx: 73.053,
    ry: 72.511
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#FFF",
    strokeWidth: 5,
    cx: 83.62,
    cy: 83,
    rx: 81.12,
    ry: 80.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.088 77.58v-5.242C69.088 63.854 75.305 57 83 57c7.695 0 13.912 6.854 13.912 15.338v5.241h4.131c2.18 0 3.957 1.959 3.957 4.363v24.695c0 2.405-1.776 4.363-3.957 4.363H64.957c-2.18 0-3.957-1.958-3.957-4.363V81.942c0-2.404 1.776-4.363 3.957-4.363h4.131zm24.678.262V72.69c0-6.606-4.79-11.9-10.766-11.9s-10.766 5.294-10.766 11.9v5.153h21.532zm-28.93 2.842c-.582 0-1.027.48-1.027 1.108v24.311c0 .627.445 1.108 1.027 1.108h36.328c.582 0 1.027-.48 1.027-1.108V81.792c0-.627-.445-1.108-1.027-1.108H64.836zM77.85 91.188c0-3.178 2.312-5.767 5.149-5.767s5.149 2.59 5.149 5.767c0 1.336-.445 2.572-1.232 3.613v3.285c0 2.418-1.758 4.388-3.917 4.388s-3.917-1.97-3.917-4.388v-3.285c-.787-1.041-1.232-2.277-1.232-3.613zm2.809.505c0 .72.28 1.376.765 1.837.328.304.52.748.52 1.21v3.773c0 .633.458 1.119 1.055 1.119s1.054-.486 1.054-1.119v-3.772c0-.463.193-.907.512-1.202.493-.47.774-1.125.774-1.846 0-1.38-1.04-2.482-2.34-2.482-1.3 0-2.34 1.103-2.34 2.482z",
    stroke: "#FFF",
    strokeWidth: 0.5,
    fill: "#FCBB00",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClSicuro);
export default __webpack_public_path__ + "static/media/cl_sicuro.efddc45064416d1865b3bb3eacac736b.svg";
export { ForwardRef as ReactComponent };